export default __webpack_public_path__ + "static/media/pinkDot.808c5945.svg";